import { useState } from 'react';

interface ReviewActionsProps {
  documentId: string;
  onApprove: (notes?: string) => void;
  onReject: (notes?: string) => void;
  isSubmitting?: boolean;
}

export default function ReviewActions({ onApprove, onReject, isSubmitting }: ReviewActionsProps) {
  const [notes, setNotes] = useState('');
  const [showNotes, setShowNotes] = useState(false);

  const handleApprove = () => {
    onApprove(notes || undefined);
  };

  const handleReject = () => {
    onReject(notes || undefined);
  };

  return (
    <div className="bg-white shadow rounded-lg p-6 mb-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Review Actions</h3>
      
      <div className="space-y-4">
        {/* Notes Section */}
        <div>
          <button
            onClick={() => setShowNotes(!showNotes)}
            className="text-sm text-primary-600 hover:text-primary-900"
          >
            {showNotes ? 'Hide notes' : 'Add notes'} (optional)
          </button>
          
          {showNotes && (
            <div className="mt-2">
              <textarea
                rows={3}
                className="block w-full rounded-md border-gray-300 shadow-sm focus:border-primary-500 focus:ring-primary-500 sm:text-sm"
                placeholder="Add any notes about your review decision..."
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                disabled={isSubmitting}
              />
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-3">
          <button
            onClick={handleApprove}
            disabled={isSubmitting}
            className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 disabled:opacity-50"
          >
            <svg className="-ml-1 mr-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            {isSubmitting ? 'Processing...' : 'Approve'}
          </button>
          
          <button
            onClick={handleReject}
            disabled={isSubmitting}
            className="flex-1 inline-flex justify-center items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 disabled:opacity-50"
          >
            <svg className="-ml-1 mr-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
            {isSubmitting ? 'Processing...' : 'Reject'}
          </button>
        </div>

        {/* Info Text */}
        <p className="text-xs text-gray-500 text-center">
          {showNotes 
            ? 'Your notes will be saved with the review decision'
            : 'Approve if all data is correct, reject to send back for reprocessing'
          }
        </p>
      </div>
    </div>
  );
}